import { render } from "./multiselect.vue?vue&type=template&id=1d386d6f&scoped=true"
import script from "./multiselect.vue?vue&type=script&lang=js"
export * from "./multiselect.vue?vue&type=script&lang=js"

import "./multiselect.vue?vue&type=style&index=0&id=1d386d6f&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d386d6f"]])

export default __exports__